export default __webpack_public_path__ + "static/media/51t.26218e10.jpg";